import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

/**
 * Decide qué vista de pagos por persona renderizar según la preferencia del
 * sistema (default_payments_view: 'tabla' | 'classic'), configurada por el admin
 * en Parámetros de Sistema > Preferencias.
 * Los componentes hijos leen el :code de la ruta vía ActivatedRoute (compartido).
 */
@Component({
  selector: 'app-person-payments-switcher',
  template: `
    <div *ngIf="view === null" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <app-person-payments-table *ngIf="view === 'tabla'"></app-person-payments-table>
    <app-person-payments *ngIf="view === 'classic'"></app-person-payments>
  `
})
export class PersonPaymentsSwitcherComponent implements OnInit {

  view: 'tabla' | 'classic' | null = null;

  constructor(private _appConfig: AppConfigService) { }

  async ngOnInit(): Promise<void> {
    try {
      const prefs = await this._appConfig.getPreferences();
      this.view = prefs?.default_payments_view === 'tabla' ? 'tabla' : 'classic';
    } catch (error) {
      console.error(error);
      this.view = 'classic';
    }
  }
}
